import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import {isWebview, setClickLogapi, vodInflowLog} from "helpers";

import { JAVASCRIPT_VOID, VOD_PLAYER_DOMAIN, APP_SCHEME } from "constant/config";
import { toastr } from "components/toastr";
import { NORMAL } from "constant/board";
import { HOME_PLAYLIST } from "constant/playlist.display";

const PlaylistLink = ({ playlist, children, className, inflowPaths, onClick = null, playlistPathType }) => {
    let { count = {}, bbsTitle: post = {}, rep_title_no = 0 } = playlist;

    const { playlist_cnt = 0 } = count;

    const { ucc = {}, station_no: stationNo = 0, bbs_no: bbsNo = 0, user_id: userId = "", title_no = 0 } = post || {};
    const { file_type: fileType = NORMAL } = ucc;

    const { t } = useTranslation();
    const playlistTitleNo = playlistPathType === HOME_PLAYLIST ? title_no : rep_title_no;

    // 빈 재생 목록 클릭
    const handleClickEmptyPlaylist = () => {
        toastr.error(t("재생 가능한 VOD가 없습니다."), { timeout: 2000 });
    };

    // 재생목록 클릭 로그 전달
    const handleVodClickLog = useCallback(() => {
        if (playlistPathType === HOME_PLAYLIST) {
            setClickLogapi("station_click", {button_group: "playlist_home", bj_id: global.bj_id});
        }
    }, [playlistPathType]);

    // 진입 로그 전달
    const handlePassVodInflowLog = useCallback(() => {
        if (typeof onClick === "function") {
            onClick();
        }
        vodInflowLog(userId, rep_title_no, inflowPaths);
    }, [inflowPaths, onClick, rep_title_no, userId]);

    // 재생목록에 영상이 없을 경우
    if (playlist_cnt === 0) {
        return (
            <a href={JAVASCRIPT_VOID} onClick={handleClickEmptyPlaylist}>
                {children}
            </a>
        );
    }

    if (isWebview) {
        //웹뷰일경우 앱실행
        return (
            <a
                href={`${APP_SCHEME}player/video?station_no=${stationNo}&bbs_no=${bbsNo}&title_no=${playlistTitleNo}&nPlaylistIdx=${playlist.idx}&type=${fileType}`}
                onClick={async () => {
                    await handleVodClickLog()
                    await handlePassVodInflowLog()
                }}
            >
                {children}
            </a>
        );
    } else {
        return (
            <a href={`${VOD_PLAYER_DOMAIN}/${playlistTitleNo}/playlist/${playlist.idx}`} className={className} target="_blank" onClick={async () => {
                await handleVodClickLog()
                await handlePassVodInflowLog()
            }}>
                {children}
            </a>
        );
    }
};

export default PlaylistLink;
